import React from 'react';
import styles from './SpotifyTrackPreview.module.css';

interface SpotifyTrack {
  name: string;
  artists: string[];
  image: string;
  id?: string;
  uri?: string;
}

interface SpotifyTrackPreviewProps {
  track: SpotifyTrack | null;
  onRemove: () => void;
}

const SpotifyTrackPreview: React.FC<SpotifyTrackPreviewProps> = ({ track, onRemove }) => {
  if (!track) return null;

  return (
    <div className={styles.container}>
      <div className={styles.trackInfo}>
        <img src={track.image} alt={track.name} className={styles.albumArt} />
        <div className={styles.details}>
          <div className={styles.name}>{track.name}</div>
          <div className={styles.artist}>{track.artists.join(', ')}</div>
        </div>
      </div>
      <button 
        onClick={onRemove} 
        className={styles.closeButton}
        type="button"
        aria-label="Remove track"
      >
        ×
      </button>
    </div>
  );
};

export default SpotifyTrackPreview; 